module.exports = __webpack_public_path__ + "static/media/icon-explain.3803ac1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-explain.svg
// module id = 947
// module chunks = 0